<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AU3N6b/tc-custom/9780830836468.jpg?1696025006629" alt="This image is the cover for the book Longing for Revival"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Longing for Revival
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>Revival begins with God. But it's lived out through us.</strong> While we can't determine how God will act, we can be expectant and anticipate his work. And revivals are not just experienced—they can be led.</p> <p>James Choung and Ryan Pfeiffer have seen revival in their own ministries, with remarkable transformation in both individuals and communities. They unpack what revival looks like, how Christians can anticipate it, and how they can experience it in their own lives and in larger movements. They provide a model of revival leadership for Christians who want to facilitate and spread revival in their contexts, with implications for evangelism, mission, and growth. We all need a spiritual breakthrough. Discover what revival can look like for you and those around you.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Choung, Ryan Pfeiffer
      </h2>
      
      <p class="authorDescription body article"><p>James Choung (DMin, Fuller Theological Seminary) is vice president of strategy and innovation for InterVarsity Christian Fellowship/USA. He previously served as InterVarsity's national director of evangelism. He is the author of <em>True Story</em> and <em>Real Life</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3bb9a572